import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ConfigContext } from '../../context/GlobalContext';
import { Languages } from '../../Utils/Languages';

const BannerInnerOne = () => {
    const { state, dispatch } = useContext(ConfigContext);
    const [isDisplayFreePlanReachedModel, setIsDisplayFreePlanReachedModel] = useState(false);

    useEffect(() => {
        const isPremium = state?.PREMIUM?.length > 0;

        if (!isPremium) {

            const currentDate = new Date();
            const currentMonth = currentDate.getMonth(); // 0-indexed (Jan = 0)
            const currentYear = currentDate.getFullYear();

            const currentMonthInvoiceCount = state?.INVOICES.filter(invoice => {
                const invoiceDate = new Date(parseInt(invoice.creationDate)); // Replace `date` with your actual date field key
                return (
                    invoiceDate.getMonth() === currentMonth &&
                    invoiceDate.getFullYear() === currentYear
                );
            }).length;


            if (currentMonthInvoiceCount >= process.env.REACT_APP_FREE_PLAN_INVOICE_LIMIT) {
                setIsDisplayFreePlanReachedModel(true)
                return;
            }
        }

    }, [])

    return (
        <div className={`col-12 ${state?.BUSINESSES?.length === 0 ? 'd-block' : 'd-none'}`}>

            <div className="nft-promo-card card radius-12 overflow-hidden position-relative z-1">
                <img
                    src="assets/images/nft/nft-gradient-bg.png"
                    className="position-absolute start-0 top-0 w-100 h-100 z-n1"
                    alt=""
                />
                <div className="nft-promo-card__inner d-flex align-items-center">
                    <div className="nft-promo-card__thumb w-100">
                        <img
                            src="../assets/images/dashboard/dashbord_banner.svg"
                            alt=""
                            className="w-100 h-100 object-fit-cover"
                        />
                    </div>
                    <div className="flex-grow-1">
                        <h5 className="mb-16 text-white">
                            {Languages[state?.LANGUAGE]?.bannerTitle}
                        </h5>
                        <p className="text-white text-md">
                            {Languages[state?.LANGUAGE]?.bannerDesc}
                        </p>
                        <div className="d-flex align-items-center flex-wrap mt-24 gap-16">
                            {/* <Link
                                to="#"
                                className="btn rounded-pill border br-white text-white radius-8 px-32 py-11 hover-bg-white text-hover-neutral-900"
                            >
                                Explore
                            </Link> */}
                            <Link
                                onClick={(e) => {
                                    if (!state?.USERID) {
                                        e.preventDefault();
                                        dispatch({ type: "GUESTMODELPOPUP", payload: true });
                                    }
                                }}
                                to={
                                    !state?.USERID
                                        ? "#"
                                        : state?.PREMIUM?.length == 0 && state?.BUSINESSES?.length > 0 && isDisplayFreePlanReachedModel == true
                                            ? "/pricing"
                                            : state?.BUSINESSES?.length > 0
                                                ? "/invoice-add"
                                                : "/business-add"
                                }
                                className="btn rounded-pill btn-primary-600 radius-8 px-28 py-11"
                            >
                                Create Invoice
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerInnerOne